import { Layout, Menu, Switch, Tooltip } from "antd";
import React, { useContext } from "react";
import {
    ClockCircleOutlined,
    HomeOutlined,
    TeamOutlined,
    SettingOutlined,
    UnorderedListOutlined,
    FormOutlined,
    AreaChartOutlined,
    UserOutlined,
    DesktopOutlined,
    GitlabOutlined,
    DotChartOutlined,
    BarChartOutlined,
    LineChartOutlined,
    DashboardOutlined,
    PullRequestOutlined,
    AccountBookOutlined,
    ContactsOutlined,
    VideoCameraOutlined,
    KeyOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { LayoutContext } from "../../../context/LayoutContext";
import logoImage from "../../../assets/images/aavgo-logo.png";
import logoDarkImage from "../../../assets/images/aavgo-logo-dark.png";
import { getUserRole, initialDateRange } from "../../../services/util";
import { SettingContext } from "../../../routes";
import { useThemeMode } from "../../../context/ThemeContext";
import { themeModes } from "../../../theme";

const { Sider } = Layout;

function getItem(path, label, icon, children) {
    return {
        path,
        key: path,
        icon,
        children,
        label,
    };
}

const defaultItems = [
    getItem("/", "Dashboard", <DesktopOutlined />),

    getItem(
        "/performance-insights",
        "Performance Insights",
        <BarChartOutlined />,
    ),
    getItem("/nexus-dashboard", "Nexus Dashboard", <DesktopOutlined />),
    getItem("/hotels", "Hotels", <HomeOutlined />),
    getItem("/users", "Users", <UserOutlined />),
    getItem("/report-settings", "Report Settings", <SettingOutlined />),
    getItem("/alarms", "Alarms", <ClockCircleOutlined />),
    getItem("/kiosk-properties", "Kiosk Properties", <UnorderedListOutlined />),
    getItem("/ticket-form", "Create Ticket", <FormOutlined />),
    getItem("/team-manangement", "Team Management", <TeamOutlined />),
    getItem("/rooms", "Rooms", <TeamOutlined />),
    getItem("/vendors", "Vendor", <DotChartOutlined />),
    getItem("1", "Back-Office", <TeamOutlined />, [
        getItem("/contacts", "Contacts", <ContactsOutlined />),
    ]),
    getItem("/video-recordings", "Video Recordings", <VideoCameraOutlined />),
    /* getItem(
        "/housekeeping-analytics",
        "House Keeping Analytics",
        <DotChartOutlined />,
    ),
    getItem(
        "/maintenance-analytics",
        "Maintenance Analytics",
        <DotChartOutlined />,
    ),
    getItem(
        "/reservation-analytics",
        "Reservation Analytics",
        <DotChartOutlined />,
    ), */
];

const CustomSider = () => {
    const userRoleId = localStorage.getItem("userRoleId");
    const userRole = getUserRole(userRoleId);
    let items = [...defaultItems];
    const {
        setSelectedNexusHotelId,
        setSelectedNexusDates,
        setCallWaitingTab,
    } = useContext(SettingContext);

    if (
        userRole === "Sales" ||
        userRole === "Front Desk Agent" ||
        userRole === "Front Desk Team Lead"
    ) {
        items = [];
        const found = items.find((e) => e.path === "/");
        if (!found) {
            items = [
                getItem("/", "Dashboard", <DesktopOutlined />),
                // getItem(
                //     "/performance-insights",
                //     "Performance Insights",
                //     <BarChartOutlined />,
                // ),
            ];
        }
    }
    if (userRole === "External Vendor" || userRole === "Customer") {
        items = [
            getItem(
                "/performance-insights",
                "Performance Insights",
                <BarChartOutlined />,
            ),
            getItem("/key-insights", "Key Insights", <KeyOutlined />),
            getItem("/ticket-form", "Create Ticket", <FormOutlined />),
        ];
    }
    if (userRole == "Front Desk Agent" || userRole === "Front Desk Team Lead") {
        const found = items.find((e) => e.path === "/rooms");
        if (!found) {
            items.push(getItem("/rooms", "Rooms", <TeamOutlined />));
        }
    }

    if (
        userRole === "Super Admin" ||
        userRole === "Admin" ||
        userRole === "Support" ||
        userRole === "Front Desk Team Lead"
    ) {
        const found = items.find((e) => e.path === "/ticket-form");
        if (!found)
            items.push(
                getItem("/ticket-form", "Create Ticket", <FormOutlined />),
            );
    }

    if (
        userRole === "Super Admin" ||
        userRole === "Admin" ||
        userRole === "Customer Success" ||
        userRole === "Management"
    ) {
        const found = items.find((e) => e.label === "Analytics");
        const perf_found = items.find((e) => e.label === "Performance Insights");

        if (!found)
            items.push(
                getItem("2", "Analytics", <AreaChartOutlined />, [
                    getItem(
                        "/analytics",
                        "Hotels Analytics",
                        <BarChartOutlined />,
                    ),
                    getItem(
                        "/git-dashboard",
                        "Git Analytics",
                        <GitlabOutlined />,
                    ),
                    getItem(
                        "/demographic-analytics",
                        "Demographic Analytics",
                        <AreaChartOutlined />,
                    ),
                    getItem(
                        "/jira-dashboard",
                        "Jira Analytics",
                        <LineChartOutlined />,
                    ),
                    getItem(
                        "/tickets-chart",
                        "Ticket Analytics",
                        <DotChartOutlined />,
                    ),
                    getItem(
                        "/sprint-analytics",
                        "Sprint Analytics",
                        <DotChartOutlined />,
                    ),
                    getItem(
                        "/support-analytics",
                        "Support Analytics",
                        <DotChartOutlined />,
                    ),
                ]),
            );
        if (perf_found){
            items = items.filter(
                item => item.key !== "/performance-insights"
            );
        }       
    }

    if (
        userRole === "Super Admin" ||
        userRole === "Admin" ||
        userRole === "Management"
    ) {
        const found = items.find((e) => e.path === "/business-analytics");
        if (!found)
            items.push(
                getItem(
                    "/business-analytics",
                    "Business Analytics",
                    <DashboardOutlined />,
                ),
            );
    }

    if (userRole === "Super Admin" || userRole === "Admin") {
        const queueModuleFound = items.find(
            (e) => e.path === "/queue-instances",
        );
        if (!queueModuleFound)
            items.push(
                getItem(
                    "/queue-instances",
                    "Queue Instances",
                    <PullRequestOutlined />,
                ),
            );
    }

    if (userRole === "Super Admin") {
        const serverModuleFound = items.find(
            (e) => e.path === "/server-instances",
        );
        const expenditureModuleFound = items.find(
            (e) => e.path === "/Expenditure",
        );
        if (!serverModuleFound)
            items.push(
                getItem(
                    "/server-instances",
                    "Server Instances",
                    <SettingOutlined />,
                ),
            );
        if (!expenditureModuleFound)
            items.push(
                getItem("/Expenditure", "Expenditure", <AccountBookOutlined />),
            );
    }

    const { collapsed, setCollapsed, isMobile, setIsMobile } =
        useContext(LayoutContext);
    const { mode, toggleTheme } = useThemeMode();
    const navigate = useNavigate();
    const isDarkMode = mode === themeModes.dark;

    const handleMenuClick = (menu) => {
        const path = items
            .filter((item) => item.key === menu.key)
            .map((item) => item.path);

        let childPath = [];
        if (path.length == 0) {
            childPath = items.reduce((prev, cur) => {
                if (cur.children) {
                    const matchedChild = cur?.children.find(
                        (child) => child.key == menu.key,
                    );
                    matchedChild?.path && prev.push(matchedChild?.path);
                }
                return prev;
            }, []);
        }
        setCallWaitingTab("call_waiting");
        setSelectedNexusDates(initialDateRange);
        if (path[0] === "/nexus-dashboard") {
            setSelectedNexusHotelId([]);
        }
        if (path.length > 0) {
            navigate(...path);
        }
        if (childPath.length > 0) {
            navigate(...childPath);
        }
    };

    return (
        <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            collapsedWidth={isMobile ? 0 : 75}
            style={{
                overflow: "auto",
                height: "95.5vh",
                position: "fixed",
                left: 0,
                top: 0,
                bottom: 0,
                borderRight: "1px solid var(--color-border)",
            }}
            breakpoint="lg"
            onBreakpoint={(bool) => {
                if (!bool) setCollapsed(false);
                setIsMobile(bool);
            }}
        >
            <div className="logo-menu">
                <img
                    src={isDarkMode ? logoImage : logoDarkImage}
                    alt="AavGo"
                    onClick={() => navigate(`/`)}
                    style={{
                        width: collapsed ? "70px" : "120px",
                    }}
                />
                <div className="theme-toggle">
                    <Tooltip
                        title={`Switch to ${
                            isDarkMode ? "light" : "dark"
                        } theme`}
                    >
                        <Switch
                            checked={isDarkMode}
                            onChange={toggleTheme}
                            checkedChildren={
                                <span style={{ color: "#fff" }}>Dark</span>
                            }
                            unCheckedChildren={
                                <span style={{ color: "#333" }}>Light</span>
                            }
                            aria-label="Toggle theme"
                        />
                    </Tooltip>
                </div>
            </div>

            <Menu
                theme={isDarkMode ? "dark" : "light"}
                defaultSelectedKeys={[window.location.pathname]}
                selectedKeys={[window.location.pathname]}
                mode="inline"
                items={items}
                onClick={handleMenuClick}
            />
        </Sider>
    );
};

export default CustomSider;
